import axiosInstance from "../utils/config";

export const fetchUser = (token) => axiosInstance.get("/user/profile", {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
  });